import './lib/link-token'; // first: strips email-link tokens from the URL before the analytics pageview
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';
import './index.css';

const container = document.getElementById('root')!;

// Prerendered public pages arrive with markup in #root and are hydrated;
// the bare shell (workspace, auth pages, shared plans) renders from scratch.
if (container.hasChildNodes()) {
  hydrateRoot(container, <App />);
} else {
  createRoot(container).render(<App />);
}
